import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import ElementUI from 'element-ui'
import router from './router'
import api from './api'
import store from './store'
import i18n from './i18n'
Vue.prototype.$api = api
Vue.prototype.$store = store
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tailwind.css'


Vue.use(ElementUI)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
